import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authHeader from "./authHeader";
import { apiInstance } from "./axiosApi";

export const getAllStudent = createAsyncThunk(
  "admin/user",
  async ({ page, limit, searchData, blockFilter }, { rejectWithValue }) => {
    try {
      let url = `/user/all`;
      if (page) {
        url += `?page=${page}&limit=${limit}`;
      }
      if (searchData) {
        url += `&search=${searchData}`;
      }
      if (blockFilter) {
        url += `&blockFilter=${blockFilter}`;
      }
      const response = await apiInstance.get(url, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const userVerifyOtp = createAsyncThunk(
  "user/verifyOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("/auth/otp/verify", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message);
    }
  }
);

export const userRegister = createAsyncThunk(
  "user/add",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("/user/add", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message);
    }
  }
);

export const userEditData = createAsyncThunk(
  "user/edit",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/user/edit`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getSingleStudent = createAsyncThunk(
  "user/userById",
  async (selectId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/user/${selectId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteStudent = createAsyncThunk(
  "admin/deleteUser",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(`/user/delete/${selectedId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getUserToken = createAsyncThunk(
  "admin/userToken",
  async (userId, { rejectWithValue }) => {
    const params = {};
    params.userId = userId;
    try {
      const response = await apiInstance.get(`/user/token`, {
        headers: authHeader(),
        params,
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getGoal = createAsyncThunk(
  "admin/allGoal",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/goal`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getExamType = createAsyncThunk(
  "admin/allExamType",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/exam-type`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  subjectLoading: false,
};

const studentSlice = createSlice({
  name: "studentSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllStudent.fulfilled, (state, action) => {
      state.studentData = action.payload.data;
      state.studentLoading = false;
    });
    builder.addCase(getSingleStudent.fulfilled, (state, action) => {
      state.singleStudentData = action.payload.data;
    });
    builder.addCase(userRegister.fulfilled, (state, action) => {
      state.newUser = action.payload.data;
      state.updateLocalStorage = false;
    });
    builder.addCase(getGoal.fulfilled, (state, action) => {
      state.goalData = action.payload.data;
    });
    builder.addCase(getExamType.fulfilled, (state, action) => {
      state.examTypeData = action.payload.data;
    });
  },
});
export default studentSlice.reducer;
